import axios from "axios";
import { baseUrl, db } from "../../firebaseConfig";
export const audioService = {
  getAudios,
  playAudio
};

axios.defaults.xsrfCookieName = process.env.VUE_APP_CSRF_COOKIE_NAME
axios.defaults.xsrfHeaderName = "X-CSRFToken"
axios.defaults.withXSRFToken = true
axios.defaults.withCredentials = true;


// async function getAudios() {
//     const audios = await db.collection('audios').get()
//     return audios.docs.map(doc => {
//         return doc.data()
//     })
// }

async function getAudios() {
  const res = await axios.get(`${baseUrl}/getAudios`, {withCredentials: true});
  return res.data.audios;
}

// async function playAudio(id, lang = '') {
//     return fetch(
//         `https://us-central1-meduberet-project.cloudfunctions.net/fetchAudio?search_lang=${lang}&match_id=${id}`)

// }

async function playAudio(id, lang = "") {
  return fetch(`${process.env.VUE_APP_API_URL}/api/sound_file/${id}/`);
}



// WEBPACK FOOTER //
// ./src/services/audioService.js